import _slicedToArray from "/opt/atlassian/pipelines/agent/build/frontend-graphql/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
var useEffect = React.useEffect;
import useDebounce from '@react-hook/debounce';
var emptyArr = [];
var emptyObj = {};
export var useWindowSize = function useWindowSize(initialWidth, initialHeight) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyObj;
  var wait = options.wait,
      leading = options.leading;

  var _useDebounce = useDebounce(
  /* istanbul ignore next */
  typeof document === 'undefined' ? [initialWidth, initialHeight] : [document.documentElement.clientWidth, document.documentElement.clientHeight], wait, leading),
      _useDebounce2 = _slicedToArray(_useDebounce, 2),
      size = _useDebounce2[0],
      setDebouncedSize = _useDebounce2[1];

  function _ref() {
    return setDebouncedSize([document.documentElement.clientWidth, document.documentElement.clientHeight]);
  }

  useEffect(function () {
    var setSize = _ref;
    window.addEventListener('resize', setSize);
    window.addEventListener('orientationchange', setSize);
    return function () {
      window.removeEventListener('resize', setSize);
      window.removeEventListener('orientationchange', setSize);
    };
  }, emptyArr);
  return size;
};
export var useWindowHeight = function useWindowHeight() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  return useWindowSize(0, initialValue, options)[1];
};
export var useWindowWidth = function useWindowWidth() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  return useWindowSize(initialValue, 0, options)[0];
};
export default useWindowSize;